export enum PaymentMethods {
    Credit = "credit",
    Pix = "pix",
    Billet = "billet",
    Link = "link",
}
